module.exports = __webpack_public_path__ + "img/jizhangindex1.d053a06a.png";